import { INTENT_CARDS } from '../../constants/intents';
import {
  AgentInterceptionType,
  messagingActions,
  TextFrameTransmissionMessage,
} from '../../reducers/messagingSlice';
import { Intents } from '../../types/intent';
import useSendMessageHooks from '../useSendMessage/useSendMessage.hooks';
import useSlashCommandReminder from '../useSlashCommandReminder.hooks';
import useAgentInterception from '../agentInterception/useAgentInterception.hooks';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { selectReadbackCallCount } from '../../redux/features/sessionBoundary/sessionBoundary.selectors';
import { incrementReadbackCallCount } from '../../redux/features/sessionBoundary/sessionBoundary.slice';
import { store } from '../../app/store';
import { selectFeatureFlagOCBReadback } from '../../redux/features/config/config.selector';
import { getMenuUnificationFeatureFlag } from '../../utils/session-storage';

const useReadback = () => {
  const dispatch = useAppDispatch();
  const { showSlashCommandReminder } = useSlashCommandReminder();
  const { sendReadBackMessage } = useSendMessageHooks();
  const { sendAgentInterception } = useAgentInterception();
  const isOCBReadbackEnabled = useAppSelector(selectFeatureFlagOCBReadback);
  const isBrandMenu = getMenuUnificationFeatureFlag();

  const sendOCBTTSMessage = (message: string) => {
    const payload: Partial<TextFrameTransmissionMessage> = {
      data: {
        payload: message,
        status: 'final',
        metadata: { intent: 'read-back' },
      },
    };
    dispatch(messagingActions.sendMessage(payload as any));
    sendAgentInterception({
      data: {
        type: AgentInterceptionType.TTS_SENT,
        description: message,
      },
    });
  };

  const handleReadBack = ({ timePressed }: { timePressed: number }) => {
    // Read the latest value from store directly to ensure we always get the current state
    const readbackCallCount = selectReadbackCallCount(store.getState());

    const readbackCard = INTENT_CARDS.find(
      (intent) => intent.intent === Intents.readback
    );
    const { intent, messages = [] } = readbackCard ?? {};

    showSlashCommandReminder();

    if (isOCBReadbackEnabled && isBrandMenu) {
      if (readbackCallCount === 0) {
        // First time: call sendOCBTTSMessage
        dispatch(incrementReadbackCallCount());
        sendOCBTTSMessage(messages?.[0] ?? '');
      } else {
        // Second time: call sendReadBackMessage
        sendReadBackMessage(intent as string, timePressed);
      }
    } else {
      // Feature flag is false: always call sendReadBackMessage
      sendReadBackMessage(intent as string, timePressed);
    }
  };

  return {
    handleReadBack,
  };
};

export default useReadback;
